import React from 'react';

/**
 * Klarna-Info-Box – v226 Masterplan Abgasanlagen:
 * Deutlich prominentere Ratenkauf-Botschaft mit dynamisch berechneter Monatsrate.
 *
 * Klarna Ratenkauf (DE): 3 zinsfreie Raten (Slice-It) für Beträge bis ca. 1000 €,
 * darüber hinaus Finanzierung 6/12/24 Monate. Wir zeigen:
 *  - < 300 €: nur den Hinweis „Rechnungskauf / Ratenkauf"
 *  - 300 - 999 €: „Oder in 3 Raten à X €"
 *  - >= 1000 €: „Ab X €/Monat mit Klarna Ratenkauf"  (24 Raten, 0 % effektiver Zins Kampagne)
 */

function fmt(n) {
  if (n == null || !isFinite(n)) return '0,00 €';
  return Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

export default function KlarnaInfo({ className = '', amount = null, placement = 'default' }) {
  const price = Number(amount) || 0;
  const rate24 = price >= 1000 ? price / 24 : 0;
  const rate3  = price >= 300 && price < 1000 ? price / 3 : 0;

  return (
    <div className={`klarna-box ${className}`} data-testid="klarna-info-box" style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '10px 12px', borderRadius: 10,
      background: 'rgba(255,180,10,0.14)', border: '1px solid rgba(255,180,10,0.55)',
      color: '#ffffff', fontSize: 13.5, margin: '10px 0',
    }}>
      <span className="klarna-badge" aria-label="Klarna" style={{
        background: '#FFA8CD', color: '#0a0a23', fontWeight: 800,
        padding: '3px 8px', borderRadius: 6, fontSize: 12, letterSpacing: 0.2,
      }}>Klarna.</span>

      <span className="klarna-text" style={{ lineHeight: 1.4, color: '#ffffff' }}>
        {rate24 > 0 && (
          <>
            <strong style={{ color: '#ffd580', fontSize: 14 }}>
              Ab {fmt(rate24)}/Monat
            </strong>
            {' '}mit Klarna Ratenkauf (24 Raten, bonitätsabhängig).
          </>
        )}
        {rate24 === 0 && rate3 > 0 && (
          <>
            <strong style={{ color: '#ffd580', fontSize: 14 }}>
              Oder in 3 Raten à {fmt(rate3)}
            </strong>
            {' '}– zinsfrei mit Klarna.
          </>
        )}
        {rate24 === 0 && rate3 === 0 && (
          <>Auch mit <strong style={{color:'#ffd580'}}>Klarna</strong> zahlbar – Rechnungskauf, Ratenkauf oder sofort.</>
        )}
      </span>
    </div>
  );
}
